import { NotificationState } from './reducer';

export const selectNotificationsState = (state: any): NotificationState =>
  state.notifications;

export const selectNotifications = (state: any) =>
  selectNotificationsState(state).notifications;
